import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;

const api = {
  DbCon: {
    ...apiFuns.genStandard("dbCon", "/api/datacenter"),
    testSql:(para)=> post('/api/datacenter/dbCon/test', para),
  }
};

export default api;
